// The shared hover pill for the public charts: navy, white text, follows the
// pointer with no show delay (the browser-native title tooltip has one).
// Coordinates are container-relative. A multiline pill takes one line per
// "\n" and sits above the pointer whatever its height.
export function createTip(el, { multiline = false } = {}) {
  const tip = document.createElement("div")
  tip.style.cssText =
    "position:absolute;display:none;pointer-events:none;z-index:2;" +
    "background:#1C2434;color:#fff;font-size:12px;padding:3px 8px;border-radius:6px;" +
    (multiline
      ? "white-space:pre;line-height:1.45;padding:5px 9px;transform:translate(-50%,calc(-100% - 12px));"
      : "white-space:nowrap;transform:translate(-50%,-135%);")
  el.appendChild(tip)
  return {
    show(x, y, text) {
      tip.textContent = text
      tip.style.top = `${y}px`
      tip.style.display = "block"
      // A wide multiline pill stays inside its container near the edges.
      const half = multiline ? tip.offsetWidth / 2 : 0
      tip.style.left = `${half ? Math.max(half, Math.min(x, el.clientWidth - half)) : x}px`
    },
    hide() {
      tip.style.display = "none"
    }
  }
}
